import { render, staticRenderFns } from "./SkupStavkaForma.vue?vue&type=template&id=31e3fe3a&scoped=true&"
import script from "./SkupStavkaForma.vue?vue&type=script&lang=js&"
export * from "./SkupStavkaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e3fe3a",
  null
  
)

export default component.exports